<template>
  <div>
    刷新间隔
    <el-select v-model="poll" placeholder="是否开启轮询" size="small" style="margin-left: 5px">
      <el-option label="默认(1min)" :value="60000"></el-option>
      <el-option label="没有刷新" :value="0"></el-option>
<!--      <el-option label="10秒" :value="10000"></el-option>-->
<!--      <el-option label="30秒" :value="30000"></el-option>-->
      <el-option label="3min" :value="180000"></el-option>
      <el-option label="5min" :value="300000"></el-option>
      <el-option label="15min" :value="900000"></el-option>
      <el-option label="1h" :value="3600000"></el-option>
    </el-select>
    <div style="float: right">
      <el-select v-model="selectIdc" placeholder="请选择idc机房"
                 multiple filterable collapse-tags style="width:210px" size="small">
        <el-option
          v-for="item in tableData"
          :key="item.id"
          :label="item.idcName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="selectDevice" placeholder="请选择设备" size="small"
                 multiple filterable collapse-tags style="width:230px;margin-left: 5px">
        <el-option
          v-for="item in deviceList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-date-picker
        v-model="time" size="small"
        type="datetimerange"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right" style="margin-left: 5px">
      </el-date-picker>
      <el-button type="primary" @click="getData(0)" size="small" style="margin-left: 5px">查询</el-button>
    </div>
    <div style="clear:both;"></div>
    <div>
      <div class="chartBox">
        <el-card style="min-height: 500px">
          <div slot="header" class="clearfix">
            <span>cpu(%)</span>
            <el-tooltip content="按下ctrl+Q固定悬浮框实现滚动查看数据及搜索功能" placement="top">
              <i class="el-icon-info" style="margin-left: 5px;font-size: 15px;vertical-align:middle"></i>
            </el-tooltip>
          </div>
          <dash-chart boxId="cpu" title="cpu" v-show="cpuSeries.length>0" tipId="cpuTip"
                      :series="cpuSeries" :dataSets="cpuDataSets"></dash-chart>
        </el-card>
      </div>
      <div class="chartBox">
        <el-card style="min-height: 500px">
          <div slot="header" class="clearfix">
            <span>内存(%)</span>
            <el-tooltip content="按下ctrl+Q固定悬浮框实现滚动查看数据及搜索功能" placement="top">
              <i class="el-icon-info" style="margin-left: 5px;font-size: 15px;vertical-align:middle"></i>
            </el-tooltip>
          </div>
          <dash-chart boxId="mem" title="内存" v-show="memSeries.length>0" tipId="memTip"
                      :series="memSeries" :dataSets="memDataSets"></dash-chart>
        </el-card>
      </div>
      <div class="chartBox">
        <el-card style="min-height: 500px">
          <div slot="header" class="clearfix">
            <span>上行带宽(kbps)</span>
            <el-tooltip content="按下ctrl+Q固定悬浮框实现滚动查看数据及搜索功能" placement="top">
              <i class="el-icon-info" style="margin-left: 5px;font-size: 15px;vertical-align:middle"></i>
            </el-tooltip>
          </div>
          <dash-chart boxId="upbandwidth" title="上行带宽" v-show="upSeries.length>0" tipId="upTip"
                      :series="upSeries" :dataSets="upDataSets"></dash-chart>
        </el-card>
      </div>
      <div class="chartBox">
        <el-card style="min-height: 500px">
          <div slot="header" class="clearfix">
            <span>下行带宽(kbps)</span>
            <el-tooltip content="按下ctrl+Q固定悬浮框实现滚动查看数据及搜索功能" placement="top">
              <i class="el-icon-info" style="margin-left: 5px;font-size: 15px;vertical-align:middle"></i>
            </el-tooltip>
          </div>
          <dash-chart boxId="downbandwidth" title="下行带宽" v-show="downSeries.length>0" tipId="dpwnTip"
                      :series="downSeries" :dataSets="downDataSets"></dash-chart>
        </el-card>
      </div>
      <div class="chartBox">
        <el-card style="min-height: 500px">
          <div slot="header" class="clearfix">
            <span>磁盘使用率(%)</span>
            <el-tooltip content="按下ctrl+Q固定悬浮框实现滚动查看数据及搜索功能" placement="top">
              <i class="el-icon-info" style="margin-left: 5px;font-size: 15px;vertical-align:middle"></i>
            </el-tooltip>
          </div>
          <dash-chart boxId="disk" title="磁盘使用率" v-show="diskSeries.length>0" tipId="diskTip"
                      :series="diskSeries" :dataSets="diskDataSets"></dash-chart>
        </el-card>
      </div>
    </div>


  </div>
</template>

<script>
import * as echarts from 'echarts'
import DashChart from "./DashChart";
import {Loading} from "element-ui";

export default {
  name: "DashBoard",
  components: {DashChart},
  data() {
    return {
      poll: 60000,
      tableData: [],
      deviceList: [],
      selectIdc: [],
      selectDevice: [],
      cpuSeries: [],
      memSeries: [],
      diskSeries: [],
      downSeries: [],
      upSeries: [],
      cpuDataSets: [],
      memDataSets: [],
      diskDataSets: [],
      downDataSets: [],
      upDataSets: [],
      time: [],
      intervalId: null,
      pickerOptions: {
        shortcuts: [{
          text: '最近三小时',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 3);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '当天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setHours(0, 0, 0, 0)
            // start.setTime(start.getTime() - end.getTime() );
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  watch: {
    poll: {
      handler(newVal, oldVal) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        if (newVal != 0) {
          this.startInterval()
        }
      },
      deep: true
    }
  },
  created() {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setHours(startDate.getHours() - 3);
    this.time = [startDate, endDate];

    this.getData(0);
    this.getIdcList();
    this.getDeviceList();
  },
  mounted() {
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
    this.intervalId = null;
  },
  methods: {
    startInterval() {
      if (this.intervalId === null) {
        this.intervalId = setInterval(this.getData, this.poll); //轮询
      }
    },
    getIdcList() {
      var data = {
        'pageNo': 1,
        'pageSize': 9999,
        'condition': "",
      };
      var _this = this;

      _this.tableData = [];
      this.$axios.post(this.baseUrl3 + 'management3/idc/list', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.tableData = data.idcList;
            // _this.totalElement = data.total;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getDeviceList() {
      const _this = this
      this.$axios.get(this.baseUrl3 + 'management3/device/findAll')
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.length > 0) {
              _this.deviceList = data;
            } else {
              _this.deviceList = [];
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getData(flag) {
      if (flag == 0) {

      } else {
        this.$set(this.time, 0, new Date(this.time[0].getTime() + this.poll)); // 更新开始日期
        this.$set(this.time, 1, new Date(this.time[1].getTime() + this.poll)); // 更新结束日期
      }

      let data = {
        "startTime": parseInt(new Date(this.time[0]).getTime() / 1000),
        "endTime": parseInt(new Date(this.time[1]).getTime() / 1000),
        "deviceIds": this.selectDevice,
        "idcIds": this.selectIdc
      }

      this.cpuSeries = [];
      this.cpuDataSets = [];
      this.memSeries = [];
      this.memDataSets = [];
      this.downSeries = [];
      this.downDataSets = [];
      this.upSeries = [];
      this.upDataSets = [];
      this.diskSeries = [];
      this.diskDataSets = [];

      this.$axios.post(this.baseUrl3 + 'management3/device/stats/query', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.length > 0) {
              for (let i = 0; i < data.length; i++) {

                //cpu
                if (data[i].cpuLoads && data[i].cpuLoads.length > 0) {
                  this.cpuSeries.push({
                    name: data[i].deviceName,
                    type: 'line',
                    smooth: false, // Smooth line
                    // showSymbol: false, // 不显示拐点
                    lineStyle: { // 设置线条为透明
                      opacity: 0
                    },
                    symbol: 'circle',
                    silent: true,
                    areaStyle: { // 使用相同的渐变色
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                          {offset: 0, color: 'rgba(172,236,167,0.8)'},  // 渐变结束颜色
                          {offset: 1, color: 'rgba(71,177,86,0.8)'} // 渐变开始颜色
                        ]
                      }
                    },
                    animationDuration: 0,//这里两个动画设置可以让图表更顺滑
                    animationEasing: 'cubicInOut',//这里两个动画设置可以让图表更顺滑
                    data: data[i].cpuLoads
                  });
                  let cpuObj = {
                    name: data[i].deviceName,
                    data: data[i].cpuLoads,
                    len: data[i].len
                  }
                  this.cpuDataSets.push(cpuObj);
                }


                // this.cpuDataSets.push(data[i].cpuLoads);
                //内存
                if (data[i].memLoads && data[i].memLoads.length > 0) {
                  this.memSeries.push({
                    name: data[i].deviceName,
                    type: 'line',
                    smooth: false, // Smooth line
                    showSymbol: true, // 不显示拐点
                    lineStyle: { // 设置线条为透明
                      opacity: 0
                    },
                    symbol: 'circle',
                    silent: true,
                    areaStyle: { // 使用相同的渐变色
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                          {offset: 0, color: 'rgba(177,220,183,0.8)'},  // 渐变结束颜色
                          {offset: 1, color: 'rgba(107,229,123,0.8)'} // 渐变开始颜色
                        ]
                      }
                    },
                    data: data[i].memLoads
                  });
                  let memObj = {
                    name: data[i].deviceName,
                    data: data[i].memLoads,
                    len: data[i].len
                  }
                  this.memDataSets.push(memObj);
                }

                // this.memDataSets.push(data[i].memLoads);

                //上行带宽
                if (data[i].upBandLoads && data[i].upBandLoads.length > 0) {
                  this.upSeries.push({
                    name: data[i].deviceName,
                    type: 'line',
                    smooth: false, // Smooth line
                    showSymbol: true, // 不显示拐点
                    lineStyle: { // 设置线条为透明
                      opacity: 0
                    },
                    symbol: 'circle',
                    silent: true,
                    areaStyle: { // 使用相同的渐变色
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                          {offset: 0, color: 'rgba(177,220,183,0.8)'},  // 渐变结束颜色
                          {offset: 1, color: 'rgba(107,229,123,0.8)'} // 渐变开始颜色
                        ]
                      }
                    },
                    data: data[i].upBandLoads
                  });
                  let upObj = {
                    name: data[i].deviceName,
                    data: data[i].upBandLoads,
                    len: data[i].len
                  }
                  this.upDataSets.push(upObj);
                }

                // this.upDataSets.push(data[i].upBandLoads);

                //下行带宽
                if (data[i].downBandLoads && data[i].downBandLoads.length > 0) {
                  this.downSeries.push({
                    name: data[i].deviceName,
                    type: 'line',
                    smooth: false, // Smooth line
                    showSymbol: true, // 不显示拐点
                    lineStyle: { // 设置线条为透明
                      opacity: 0
                    },
                    symbol: 'circle',
                    silent: true,
                    areaStyle: { // 使用相同的渐变色
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                          {offset: 0, color: 'rgba(177,220,183,0.8)'},  // 渐变结束颜色
                          {offset: 1, color: 'rgba(107,229,123,0.8)'} // 渐变开始颜色
                        ]
                      }
                    },
                    data: data[i].downBandLoads
                  });
                  let downObj = {
                    name: data[i].deviceName,
                    data: data[i].downBandLoads,
                    len: data[i].len
                  }
                  this.downDataSets.push(downObj);
                }

                // this.downDataSets.push(data[i].downBandLoads);

                //磁盘使用率
                if (data[i].diskLoads && data[i].diskLoads.length > 0) {
                  this.diskSeries.push({
                    name: data[i].deviceName,
                    type: 'line',
                    smooth: false, // Smooth line
                    showSymbol: true, // 不显示拐点
                    lineStyle: { // 设置线条为透明
                      opacity: 0
                    },
                    symbol: 'circle',
                    silent: true,
                    areaStyle: { // 使用相同的渐变色
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                          {offset: 0, color: 'rgba(177,220,183,0.8)'},  // 渐变结束颜色
                          {offset: 1, color: 'rgba(107,229,123,0.8)'} // 渐变开始颜色
                        ]
                      }
                    },
                    data: data[i].diskLoads
                  });
                  let diskObj = {
                    name: data[i].deviceName,
                    data: data[i].diskLoads,
                    len: data[i].len
                  }
                  this.diskDataSets.push(diskObj);
                }

              }
            }
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>
.chartBox {
  width: 48%;
  display: inline-block;
  margin: 5px;
}
</style>
